import { createSelector } from "reselect";
import get from "lodash.get";
import {
  hasAllowEditOtherUsersWorkPermissionSelector,
  hasSignWoundRevisionPermissionSelector
} from "src/selectors/ui_config_selectors/patients";
import { createNestedAssessmentSchemasForAssessmentAnswerSelector } from "src/selectors/data_selectors";
import { createRevisionIsFirstInSeriesSelector } from "src/selectors/data_selectors/revisions/create_revision_is_first_in_series_selector";
import { assessmentAnswersResourceSelectors } from "src/selectors/data_selectors";
import { currentUserSelector } from "src/selectors/config_selectors/current_user_selector";
import { isMissingRequiredFields } from "src/models/assessment_answers";
import { containsRequiredFieldsForAssessmentAnswers } from "src/utils/required_fields";

export function createSignIsDisabledSelector({
  assessmentAnswer,
  revision,
  schemas
}) {
  return createSelector(
    hasAllowEditOtherUsersWorkPermissionSelector,
    createNestedAssessmentSchemasForAssessmentAnswerSelector(assessmentAnswer),
    createRevisionIsFirstInSeriesSelector(revision),
    hasSignWoundRevisionPermissionSelector,
    currentUserSelector,
    assessmentAnswersResourceSelectors.putLoadStateSelector,
    (
      canEditOtherUsersWork,
      nestedAssessmentSchemas,
      revisionIsFirstInSeries,
      canSignWoundRevisions,
      currentUser,
      putLoadState
    ) => {
      const assessmentAnswerAnswersJson =
        assessmentAnswer.attributes.answersJson;
      const revisionAuthorId = get(revision, "attributes.userId", null);
      const isRevisionAuthor =
        revisionAuthorId && revisionAuthorId === currentUser.id;
      const hasRequiredFields = !isMissingRequiredFields(
        nestedAssessmentSchemas,
        assessmentAnswer,
        revisionIsFirstInSeries
      );
      return (
        (!canEditOtherUsersWork && !isRevisionAuthor) ||
        !hasRequiredFields ||
        !containsRequiredFieldsForAssessmentAnswers(
          schemas,
          assessmentAnswerAnswersJson,
          revisionIsFirstInSeries
        ) ||
        !canSignWoundRevisions ||
        putLoadState[assessmentAnswer.id] === "loading"
      );
    }
  );
}
